import {
  calculateHoursFromTimeRange,
  deductStatutoryBreak,
  formatHours,
} from '../../types/bedarf';

interface TagesArbeitszeitProps {
  startTime: string | null | undefined;
  endTime: string | null | undefined;
  className?: string;
}

/**
 * Arbeitszeit eines Tages unter seinen Zeiten. Wurde die Pflichtpause abgezogen,
 * steht das dabei — sonst passten „08:00 - 15:00" und „6h 30min" nicht zusammen.
 */
export default function TagesArbeitszeit({ startTime, endTime, className = '' }: TagesArbeitszeitProps) {
  const anwesenheit = calculateHoursFromTimeRange(startTime, endTime);
  const arbeitszeit = deductStatutoryBreak(anwesenheit);
  const pauseAbgezogen = arbeitszeit < anwesenheit;

  return (
    <div className={`text-xs text-gray-500 ${className}`}>
      {formatHours(arbeitszeit)}
      {pauseAbgezogen && (
        <div
          className="text-[11px] text-gray-400"
          title="Über 6 Stunden am Tag sind 30 Minuten Pause gesetzlich vorgeschrieben (§ 4 ArbZG) und zählen nicht als Arbeitszeit."
        >
          − 30 min Pause
        </div>
      )}
    </div>
  );
}
